



























import {
  defineComponent, ref, useContext,
} from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'ElementSingleImage',
  props: {
    element: {
      type: Object,
      require: true
    }
  },
  setup(props) {
    const {$config} = useContext();

    const image = ref(props.element.image);
    const overlay = ref(props.element.overlay_color);
    const contentBg = ref(props.element.content_background);
    const contentColor = ref(props.element.content_color);
    const display = ref(!props.element.display_on_hover);

    return {
      display,
      contentBg,
      contentColor,
      overlay,
      image,
      magentoMediaUrl: $config.magentoMediaUrl
    }
  },
  methods: {
    getImageSrc(image) {
      if (this.element.source === "media_library") {
        return `${this.magentoMediaUrl}/${image}`
      }

      return image;
    },
    getSrcset() {
      let srcset = '';

      if (this.element.tablet_image) {
        srcset += `${this.getImageSrc(this.element.tablet_image)} 1024w, `
      }

      if (this.element.landscape_phone_image) {
        srcset += `${this.getImageSrc(this.element.landscape_phone_image)} 768w, `
      }

      if (this.element.portrait_phone_image) {
        srcset += `${this.getImageSrc(this.element.portrait_phone_image)} 576w, `
      }

      if (srcset) {
        srcset = `${this.getImageSrc(this.element.image)} 1200w, ${srcset}`;

        srcset = srcset.substring(0, srcset.length - 2);
      }

      return srcset;
    },
    getSources() {
      const sources = [];

      if (this.element.tablet_image) {
        sources.push({
          srcset: this.getImageSrc(this.element.tablet_image),
          media: '(min-width: 1024px)'
        })
      }

      if (this.element.landscape_phone_image) {
        sources.push({
          srcset: this.getImageSrc(this.element.landscape_phone_image),
          media: '(min-width: 768px)'
        })
      }

      if (this.element.portrait_phone_image) {
        sources.push({
          srcset: this.getImageSrc(this.element.portrait_phone_image),
          media: '(min-width: 576px)'
        })
      }

      return sources;
    },
    getHoverClassEffect() {
      const classes = [];
      if (this.element.image_hover_effect) {
        classes.push(`hover-type-${this.element.image_hover_effect}`);
      }
      if (this.element.content_position) {
        classes.push(`mgz-flex-position-${this.element.content_position}`);
      }

      return classes;
    },
    mouseEnter() {
      if (this.element.hover_image) {
        this.image = this.element.hover_image;
      }
      if (this.element.content_hover_background) {
        this.contentBg = this.element.content_hover_background;
      }
      if (this.element.content_hover_color) {
        this.contentColor = this.element.content_hover_color;
      }
      if (this.element.hover_overlay_color) {
        this.overlay = this.element.hover_overlay_color;
      }
      if (this.element.display_on_hover) {
        this.display = this.element.display_on_hover;
      }
    },
    mouseLeave() {
      if (this.element.hover_image) {
        this.image = this.element.image;
      }
      if (this.element.content_hover_background) {
        this.contentBg = this.element.content_background;
      }
      if (this.element.content_hover_color) {
        this.contentColor = this.element.content_color;
      }
      if (this.element.hover_overlay_color) {
        this.overlay = this.element.overlay_color;
      }
      if (this.element.display_on_hover) {
        this.display = !this.element.display_on_hover;
      }
    },
    getImageWidth() {
      if (this.element.image_width) {
        if (!(this.element?.image_width?.indexOf('%') > -1)) {
          return `${this.element.image_width}px`;
        } else {
          return `${this.element.image_width}`;
        }
      }

      return false;
    },
    getParentStyle() {
      const style = {};
      if (this.getImageWidth()) {
        style['width'] = this.getImageWidth()
      }

      return style;
    },
    getImageStyles() {
      const style = {};
      if (this.getImageWidth()) {
        style['width'] = this.getImageWidth()
      }

      if (this.element.image_width) {
        style['height'] = `${this.element.image_height}px`
      }
      if (this.element.image_border_style) {
        style['border-style'] = this.element.image_border_style;
      }
      if (this.element.image_border_color) {
        style['border-color'] = this.element.image_border_color;
      }
      if (this.element.image_border_width) {
        style['border-width'] = `${this.element.image_border_width}px`;
      }

      return style;
    },
    getTitleStyles() {
      const style = {};

      if (this.element.title_font_size) {
        style['font-size'] = `${this.element.title_font_size.replace('px', '')}px`
      }
      if (this.element.title_font_weight) {
        style['font-weight'] = this.element.title_font_weight;
      }

      return style;
    },
    getDescStyles() {
      const style = {};

      if (this.element.description_font_size) {
        style['font-size'] = `${this.element.description_font_size.replace('px', '')}px`
      }
      if (this.element.description_font_weight) {
        style['font-weight'] = this.element.description_font_weight;
      }

      return style;
    },
    getContentStyles() {
      const style = {};

      if (this.element.content_align) {
        style['text-align'] = this.element.content_align;
      }
      if (this.element.content_background) {
        style['background'] = this.contentBg;
      }
      if (this.element.content_color) {
        style['color'] = this.contentColor;
      }

      return style;
    }
  }
});
